/** Значение токена темы как цвет, понятный MapLibre.
 *
 *  MapLibre разбирает цвета САМ и `rgb(var(--accent))` не понимает: строка
 *  доходит до его парсера как есть и роняет добавление слоя целиком. Поэтому
 *  токен читается из вычисленных стилей и превращается в обычный `rgb(r,g,b)`.
 *
 *  Токены кабинета хранятся КАНАЛАМИ («46 158 143») — так их кладёт бренд-пак,
 *  чтобы работали alpha-модификаторы Tailwind (`rgb(var(--accent) / 50%)`).
 */
export const NEUTRAL_LINE = 'rgb(148,163,184)'

/** Каналы токена → `rgb(r,g,b)`. Чистая половина: её и проверяют тесты, потому
 *  что набор тестов кабинета работает без DOM. */
export function parseTokenColor(raw: string, fallback = NEUTRAL_LINE): string {
  // Запятые, а не пробелы: пробельный синтаксис CSS Color 4 понимают не все
  // разборщики цвета, запятые понимают все.
  const parts = raw.trim().split(/[\s,]+/).filter(Boolean).map(Number)
  if (parts.length < 3 || parts.some(v => !Number.isFinite(v))) return fallback
  return `rgb(${parts[0]},${parts[1]},${parts[2]})`
}

export function tokenColor(name: string, fallback = NEUTRAL_LINE): string {
  if (typeof document === 'undefined') return fallback
  return parseTokenColor(
    getComputedStyle(document.documentElement).getPropertyValue(name),
    fallback,
  )
}
